import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
import { BuildPriceSiteServedAd } from 'site-modules/shared/components/native-ad/buildprice-site-served-ad/buildprice-site-served-ad';
import { BuildPriceSiteServedNarrowAd } from 'site-modules/shared/components/native-ad/buildprice-site-served-ad/buildprice-site-served-narrow-ad';
import { BuildPriceSiteServedAdCtaOnly } from 'client/site-modules/shared/components/native-ad/buildprice-site-served-ad/buildprice-site-served-ad-cta-only';
import { NativeAd } from 'site-modules/shared/components/ad-unit/native-ad';
import {
  BuildPriceCreativeConfigPropTypes,
  BuildPriceCreativeConfigDefaultProps,
} from 'client/data/models/native-ads-creative-config';
import {
  AdComponentDefaultProps,
  AdComponentPropTypes,
} from 'site-modules/shared/components/ad-unit/ad-unit-prop-types';

import { BUILD_PRICE_AD } from 'client/site-modules/shared/components/native-ad/utils/constants';
import { withSiteServedAdWrapper } from 'client/site-modules/shared/components/native-ad/site-served-ad-wrapper/site-served-ad-wrapper';

export function BuildPriceAdUI({
  creativeConfig = BuildPriceCreativeConfigDefaultProps,
  currentVehicle = AdComponentDefaultProps.currentVehicle,
  vehicle = AdComponentDefaultProps.vehicle,
  mobile = AdComponentDefaultProps.mobile,
  includeMrectAdCall = false,
  wrapperClass = AdComponentDefaultProps.wrapperClass,
  slotRenderEndListener = AdComponentDefaultProps.slotRenderEndListener,
  withDFPFallback,
  siteServedAdsEnabled = AdComponentDefaultProps.siteServedAdsEnabled,
  position = AdComponentDefaultProps.position,
  placeholderComponent = AdComponentDefaultProps.placeholderComponent,
  placeholderComponentProps = AdComponentDefaultProps.placeholderComponentProps,
  customTargeting = AdComponentDefaultProps.customTargeting,
  ivtClassName = AdComponentDefaultProps.ivtClassName,
  showOnlyNarrowView = false,
  hideJelly = false,
  ads12450Recipe = null,
  onBuildPriceAdLoadedCallback = null,
}) {
  const nativeAdProps = {
    refreshDisableWhenZipChanged: siteServedAdsEnabled,
    slotRenderEndListener,
    position,
    placeholderComponent,
    placeholderComponentProps,
    customTargeting,
    siteServedAdsUpdater: get(creativeConfig, 'siteServedAdsUpdater'),
    currentVehicle,
  };

  const adUnitWithDFPFallback = includeMrectAdCall ? (
    <NativeAd
      wrapperClass="build-price w-100"
      adNameWired="mrect,native"
      adNameMobile="mmrect,mnative"
      nativeStyle="buildprice,mediumrectangle"
      refreshable={false}
      customSizes={[[1, 1], [300, 250], 'fluid']}
      {...nativeAdProps}
    />
  ) : (
    <NativeAd nativeStyle="buildprice" wrapperClass="build-price w-100" {...nativeAdProps} />
  );

  const renderBuildPriceSiteServedAd =
    hideJelly && showOnlyNarrowView ? (
      <BuildPriceSiteServedNarrowAd
        mobile={mobile}
        position={position}
        creativeConfig={creativeConfig}
        vehicle={vehicle}
        currentVehicle={currentVehicle}
        customTargeting={customTargeting}
        wrapperClass="my-1"
      />
    ) : (
      <BuildPriceSiteServedAd
        mobile={mobile}
        position={position}
        creativeConfig={creativeConfig}
        vehicle={vehicle}
        currentVehicle={currentVehicle}
        customTargeting={customTargeting}
        wrapperClass="my-1"
        showOnlyNarrowView={showOnlyNarrowView}
        hideJelly={hideJelly}
      />
    );
  if (['chal1', 'chal2'].includes(ads12450Recipe)) {
    return (
      <BuildPriceSiteServedAdCtaOnly
        position={position}
        creativeConfig={creativeConfig}
        vehicle={vehicle}
        currentVehicle={currentVehicle}
        customTargeting={customTargeting}
        onAdLoadedCallback={onBuildPriceAdLoadedCallback}
        mobile={mobile}
      />
    );
  }

  return (
    <div className={classnames('build-price-unit', wrapperClass, ivtClassName)}>
      {withDFPFallback ? adUnitWithDFPFallback : renderBuildPriceSiteServedAd}
    </div>
  );
}

BuildPriceAdUI.propTypes = {
  ...AdComponentPropTypes,
  creativeConfig: BuildPriceCreativeConfigPropTypes,
  includeMrectAdCall: PropTypes.bool,
  showOnlyNarrowView: PropTypes.bool,
  hideJelly: PropTypes.bool,
  ads12450Recipe: PropTypes.string,
  onBuildPriceAdLoadedCallback: PropTypes.func,
};

const BuildPriceAdWrapper = withSiteServedAdWrapper(BuildPriceAdUI);

export function BuildPriceAd(props) {
  return <BuildPriceAdWrapper {...props} adType={BUILD_PRICE_AD} />;
}
